















import { isDragEvent } from '@/utilities/guards';
import Vue from 'vue';

export default Vue.extend({
  props: {
    disabled: { type: Boolean, default: false },
  },

  data() {
    return {};
  },

  methods: {
    selectFiles() {
      if (this.disabled) {
        return;
      }

      const file: HTMLInputElement = this.$refs.file as HTMLInputElement;

      file.click();
      this.$emit('open');
    },

    onFileChange(e: InputEvent | DragEvent) {
      let files: FileList | undefined | null;

      if (isDragEvent(e)) {
        files = e.dataTransfer?.files;
      } else {
        files = (e.target as HTMLInputElement).files;
      }

      if (!files?.length) {
        return;
      }

      this.$emit('input', true);
      this.$emit('add', files);
    },
  },
});
